
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.3 7.1L10.5.3c-.3-.2-.7-.2-1 0L.7 7.1c-.2.1-.3.4-.3.6V19c0 .4.4.8.8.8h5.9c.4 0 .8-.4.8-.8v-5.4h4V19c0 .4.4.8.8.8h5.9c.4 0 .8-.4.8-.8V7.7c.2-.2.1-.5-.1-.6zM18 18.2h-4.3v-5.4c0-.4-.4-.8-.8-.8H7.2c-.4 0-.8.4-.8.8v5.4H2V8.1L10 2l8 6.2v10z"}})])
          )
        }
      }
    